import { Box, Stack, Table, TableBody, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { AuthoringRichTextReadOnly } from "authoring/components/authoring-rich-text-readonly"
import { hasAmendsContent } from "authoring/routes/project/amends/lib/amends-content"
import { ScheduleCommentaryUpdateRow } from "./schedule-commentary-update-row"
import { ScheduleCommentaryEditSectionButton } from "./schedule-commentary-edit-section-button"
import { ScheduleCommentaryRemoveSectionButton } from "./schedule-commentary-remove-section-button"

export function ScheduleCommentaryCategorySection({ item }) {
    return (
        <Box data-cy="schedule-commentary-category-section">
            <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mb: 1.5 }}>
                <Typography variant="h6" sx={{ color: "primary.main", fontWeight: 700 }}>
                    {item.title}
                </Typography>
                <If truthy={!item.readOnly}>
                    <ScheduleCommentaryEditSectionButton section={item} />
                </If>
                <If truthy={item.custom}>
                    <ScheduleCommentaryRemoveSectionButton section={item} />
                </If>
            </Stack>
            <If truthy={Boolean(item.description)}>
                <Typography variant="body2" sx={{ mb: 1.5 }}>
                    {item.description}
                </Typography>
            </If>
            <If truthy={hasAmendsContent(item.content)}>
                <Box sx={{ mb: 1.5 }}>
                    <AuthoringRichTextReadOnly content={item.content} dataCy="schedule-commentary-section-content" />
                </Box>
            </If>
            <Table size="small" sx={{ pl: 3 }}>
                <TableBody>
                    <Repeat list={item.schedules} item={<ScheduleCommentaryUpdateRow />} keyFn={(s) => s.scheduleId} />
                </TableBody>
            </Table>
        </Box>
    )
}
